import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ThemeFileIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ThemeFile",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M29.96 10.57a2 2 0 0 0-.12-.35s0-.07 0-.07q-.105-.165-.24-.3l-7.48-7.48c-.08-.07-.18-.14-.28-.19s-.08 0-.08 0c-.08-.04-.17-.08-.27-.1s-9.67 0-9.67 0a4.2 4.2 0 0 0-4.2 4.11V9.6c-3.22.67-5.6 3.49-5.6 6.86s2.38 6.18 5.55 6.85h.05v2.92c0 2.2 1.73 3.73 4.2 3.73h14c2.47 0 4.2-1.54 4.2-3.73V10.58h-.03Zm-2.77 15.67c0 .77-.76.97-1.4.97h-14c-.64 0-1.4-.17-1.4-.97v-2.92c3.23-.66 5.62-3.47 5.62-6.85 0-1.62-.55-3.11-1.47-4.29v.02l-4.15 4.16-.23.27a.97.97 0 0 1-1.44-.85c0-.17.05-.34.13-.48s1.56-1.59 1.56-1.59l2.84-2.84c-.8-.62-1.75-1.07-2.79-1.28h-.05V6.17c0-.77.63-1.4 1.4-1.4h7.93V9.9c0 1.29 1.04 2.33 2.33 2.33h5.13v14Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M21.29 29.29h-3.43c-1.26 0-2.29-1.03-2.29-2.29v-9.14c0-1.26 1.03-2.29 2.29-2.29h3.43c1.26 0 2.29 1.03 2.29 2.29V27a2.29 2.29 0 0 1-2.29 2.29m-3.43-11.43V27h3.43v-9.14z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.14 29.29H5.28c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43h13.71c.3 0 .59.12.81.33l9.14 9.14c.45.45.45 1.17 0 1.62s-1.17.45-1.62 0l-8.81-8.81H5.29c-.63 0-1.14.51-1.14 1.14v20.57c0 .63.51 1.14 1.14 1.14h6.86a1.14 1.14 0 1 1 0 2.28Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.14 15.57c-.63 0-1.14-.51-1.14-1.14v-1.14h-5.71c-1.89 0-3.43-1.54-3.43-3.43V3a1.14 1.14 0 1 1 2.28 0v6.86c0 .63.51 1.14 1.14 1.14h6.86c.63 0 1.14.51 1.14 1.14v2.29c0 .63-.51 1.14-1.14 1.14M22.86 27.43c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62L27 20.53l-.77-.77a1.14 1.14 0 0 1 0-1.62 1.15 1.15 0 0 1 1.62 0l.77.77c.43.43.67 1 .67 1.62s-.24 1.19-.67 1.62l-4.95 4.95c-.22.22-.52.33-.81.33"
      }), /*#__PURE__*/_jsx("path", {
        d: "M27 29.29h-9.14a1.14 1.14 0 1 1 0-2.28H27a1.14 1.14 0 1 1 2.28 0 2.29 2.29 0 0 1-2.29 2.29Z"
      })]
    })
  }));
};
ThemeFileIcon.displayName = 'ThemeFileIcon';